import React from 'react';
import { Navigate } from 'react-router-dom';

export default function RoomsSuite() {
  return <Navigate to="/rooms" replace />;
}
